import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import FJUtil from '@src/util/FJUtil';

/** 全屏主流程页标识（互斥，同时仅展示其一） */
export const FJ_COMMON_VIEW = {
    START_LANDING: 'startLanding',
    SETTING: 'setting',
    GENERATING: 'generating',
    DETAILS: 'details',
    FAILED: 'failed',
} as const;

export type FJCommonView = (typeof FJ_COMMON_VIEW)[keyof typeof FJ_COMMON_VIEW];

type CreditsInfoApi = {
    total?: number | string;
};

/** 从 `get-credit-info` 返回的 `data.total` 解析积分总额；无法解析时为 `0` */
export function totalCreditsFromApi(data: unknown): number {
    if (data == null || typeof data !== 'object') return 0;
    const t = (data as CreditsInfoApi).total;
    if (typeof t === 'number' && Number.isFinite(t)) return t;
    if (typeof t === 'string' && t !== '' && !Number.isNaN(Number(t))) return Number(t);
    return 0;
}

export type FJCommonState = {
    activeView: FJCommonView;
    /** 积分总额（接口 `total`），默认 `0` */
    totalCredits: number;
    /** 免费次数，默认 `0` */
    freeTimes: number;
};

const initialState: FJCommonState = {
    activeView: FJ_COMMON_VIEW.START_LANDING,
    totalCredits: FJUtil.isLocalhost() ? 999 : 0,
    freeTimes: FJUtil.isLocalhost() ? 999 : 0,
};

const fjCommonSlice = createSlice({
    name: 'common',
    initialState,
    reducers: {
        setActiveView: (state, action: PayloadAction<FJCommonView>) => {
            state.activeView = action.payload;
        },
        setTotalCredits: (state, action: PayloadAction<number>) => {
            state.totalCredits = action.payload;
        },
        setFreeTimes: (state, action: PayloadAction<number>) => {
            state.freeTimes = action.payload;
        },
    },
});

export const { setActiveView, setTotalCredits, setFreeTimes } = fjCommonSlice.actions;
export default fjCommonSlice.reducer;
